var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#007ACC;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st0",
    points: "67.5,250 67.5,432.5 250,432.5 432.5,432.5 432.5,250 432.5,67.5 250,67.5 67.5,67.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st1",
    d: "M148.2,251.2l-0.1,14.9h23.8h23.8v67.5v67.5h16.8h16.8v-67.5v-67.5H253h23.8v-14.7 c0-8.1-0.2-14.9-0.4-15.1c-0.2-0.2-29.1-0.3-64.1-0.3l-63.8,0.2L148.2,251.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M362,235.9c9.3,2.3,16.3,6.4,22.8,13.2c3.4,3.6,8.3,10.1,8.7,11.7c0.1,0.5-15.8,11.1-25.4,17.1 c-0.3,0.2-1.7-1.3-3.3-3.6c-4.7-6.8-9.6-9.8-17.1-10.3c-11.1-0.8-18.2,5-18.1,14.7c0,2.8,0.4,4.5,1.6,6.8c2.4,5,7,8.1,21.1,14.2 c26.1,11.2,37.3,18.7,44.3,29.2c7.8,11.8,9.5,30.5,4.2,44.5c-5.8,15.2-20.2,25.5-40.4,28.9c-6.3,1.1-21.1,0.9-27.8-0.3 c-14.7-2.6-28.6-9.8-37.1-19.4c-3.4-3.7-9.9-13.4-9.5-14.1c0.2-0.2,1.7-1.2,3.4-2.1c1.6-0.9,7.8-4.5,13.6-7.8l10.5-6.1l2.2,3.2 c3.1,4.7,9.8,11.1,13.8,13.3c11.6,6.1,27.6,5.3,35.5-1.8c3.4-3.1,4.8-6.3,4.8-10.9c0-4.2-0.5-6.1-2.7-9.3 c-2.8-4.1-8.6-7.5-25.1-14.6c-18.8-8.1-26.9-13.2-34.4-21.1c-4.3-4.6-8.3-12.1-10-18.2c-1.4-5.2-1.7-18.1-0.6-23.3 c3.9-18.2,17.6-30.9,37.4-34.6C340.8,233.9,355.7,234.3,362,235.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.b939a2d1b7b5da4819e25cf4a4a62420.svg";
export { ForwardRef as ReactComponent };